import {
  ChangeDetectionStrategy,
  Component, effect,
  inject,
  Inject,
  signal
} from '@angular/core';
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {Router, RouterOutlet} from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "./shared/state/app.state";
import { AuthService } from "./shared/service/auth.service";
import { environment } from "../environments/environment";
import { ApplicationInsights } from "@microsoft/applicationinsights-web"
import { AngularPlugin } from "@microsoft/applicationinsights-angularplugin-js";
import {Button} from "primeng/button";
import {BsTopNavigationComponent} from "./shared/ui/bs-top-navigation/bs-top-navigation.component";
import {Toast} from "primeng/toast";
import {BsSideNavigationComponent} from "./shared/ui/bs-side-navigation/bs-side-navigation.component";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    Button,
    BsTopNavigationComponent,
    Toast,
    BsSideNavigationComponent,
  ],
  standalone: true
})
export class AppComponent {
  bsAuthService = inject(AuthService);
  appInsights: ApplicationInsights;
  title = 'Steelworks';
  customerId = '';
  roleId = signal<string>('');
  customerEmail = '';
  showCuiBanner = signal(false);

  private readonly destroying$ = new Subject<void>();

  buttonTextPrimaryHoverBackground = {
    textPrimaryHoverBackground: '#d1d1d1',
  };

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private broadcastService: MsalBroadcastService, private authService: MsalService, private router: Router, private store: Store<AppState>) {
    if (environment.production) {
      var angularPlugin = new AngularPlugin();
      // *** Add the Click Analytics plug-in. ***
      /* var clickPluginInstance = new ClickAnalyticsPlugin();
         var clickPluginConfig = {
           autoCapture: true
         }; */
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: environment.appInsights.connectionString,
          // *** If you're adding the Click Analytics plug-in, delete the next line. ***
          extensions: [angularPlugin],
          // *** Add the Click Analytics plug-in. ***
          // extensions: [angularPlugin, clickPluginInstance],
          extensionConfig: {
            [angularPlugin.identifier]: { router: this.router }
            // *** Add the Click Analytics plug-in. ***
            // [clickPluginInstance.identifier]: clickPluginConfig
          }
        }
      });
      this.appInsights.loadAppInsights();
    }

    effect(() => {
      if(this.showCuiBanner()){
        document.documentElement.style.setProperty("--p-bs-topnav-height", '104px');
      } else {
        document.documentElement.style.setProperty("--p-bs-topnav-height", '52px')
      }
    })

  }

  acknowledgeCuiBanner() {
    this.showCuiBanner.set(false);
    const currentDate = new Date();
    localStorage.setItem("cuiBannerAcknowledged", (currentDate.setHours(currentDate.getHours() + 48)).toString())
  }

  ngOnInit() {
    const cuiBannerAcknowledged = localStorage.getItem("cuiBannerAcknowledged");

    this.bsAuthService.customerClaimReplay
      .pipe(takeUntil(this.destroying$))
      .subscribe((claims: any) => {
        this.customerId = claims?.customerId ?? '';
        this.customerEmail = claims?.email ?? '';

        if (environment.production) {
          this.appInsights.setAuthenticatedUserContext(this.customerEmail);
        }

        if ((this.customerId === 'BrennerSoftware' || this.customerId === 'hhiCorporation' || this.customerId === 'hhiCorporationSales')) {
          if (cuiBannerAcknowledged) {
            this.showCuiBanner.set(new Date(Number(cuiBannerAcknowledged) + 1000).getTime() < new Date().getTime());
          } else {
            this.showCuiBanner.set(true);
          }
        }
      });
  }
}
